<script setup lang="ts">
import { ref, watch } from 'vue'
import { apiPost } from '@/lib/http'
import { useStaticAsset } from '@/composables/useStaticAsset'

const asset = useStaticAsset()

const props = defineProps<{
  modelValue?: boolean
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const submitted = ref(false)
const submitting = ref(false)
const error = ref('')
const email = ref('')

watch(
  () => props.modelValue,
  value => {
    if (value) return
    submitted.value = false
    error.value = ''
    email.value = ''
  }
)

function open(value: string) {
  emit('update:modelValue', true)
  email.value = value
}

defineExpose({
  $open: open
})

async function submit() {
  if (submitting.value) return
  submitting.value = true

  if (!email.value) {
    error.value = 'Это обязательное поле.'
    submitting.value = false
    return
  }

  const result = await apiPost('/users/request_forgot_password', { email: email.value })

  submitting.value = false

  if (result.failed) {
    error.value = result.errors?.email?.[0]?.message ?? 'Произошла ошибка'
    return
  }

  submitted.value = true
}
</script>

<template>
  <v-rich-modal
    title="Восстановление пароля"
    :model-value="props.modelValue"
    @update:model-value="() => emit('update:modelValue', false)"
  >
    <div v-if="submitted" class="login-recovery-modal__submitted">
      <img :src="asset('img/ok.svg')" width="48" height="48" />
      <p class="my-2">Ссылка для восстановления пароля отправлена на вашу электронную почту.</p>
      <p>После восстановления обновите эту страницу, чтобы продолжить.</p>
    </div>

    <template v-else>
      <v-field label="Электронная почта">
        <v-input
          v-model.trim="email"
          type="email"
          name="email"
          autocomplete="username"
          :error="error"
          @keyup.enter="submit"
        />
      </v-field>
    </template>

    <template v-if="!submitted" #actions>
      <v-button mode="primary large" :disabled="submitting" @click="submit"> Восстановить </v-button>
      <v-button class="ml-2" mode="primary text" @click="emit('update:modelValue', false)"> Назад </v-button>
    </template>
  </v-rich-modal>
</template>

<style lang="scss">
.login-recovery-modal {
  &__submitted {
    @include desktop {
      width: 320px;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>
